<template>
    <div class="container">
            <div class="seach-container">
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">关键字</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-input
                                v-model="query.keyword"
                                size="small"
                                placeholder="请输入用户名或网点名"
                            ></el-input>
                            </div>
                        </div>
                    </div>   
                        <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">银行名称</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.BankID" size="small" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option :label="bank.BankName" :value="bank.BankID" :key="bank.BankID" v-for="bank in bankList"></el-option>
                            </el-select>
                            </div>
                        </div>
                    </div>
                      <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">区域</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.AreaCode" size="small" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option :label="area.AreaName" :value="area.AreaCode" :key="area.AreaCode" v-for="area in areaList"></el-option>
                            </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-container">
                        <div class="form-box-item serch-operate" >
                               <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">搜索</el-button>
                               <el-button  size="mini" icon="el-icon-delete" @click="handleEmpty">清空</el-button>
                        </div>
                    </div>
            </div>
            <div class="addBtn">
                 <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button> 
            </div>
           <el-table
                :data="tableData"
                border
                :max-height="scrollHeight"
            >
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
                                 <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleUpdate(scope.$index, scope.row)">修改</el-button>
                                 <el-button
                                 icon="el-icon-delete"
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </div>
                             <div v-else-if="(scope.column.property==='Type')">
                                <span v-if="(scope.row.Type)">否</span>
                                <span v-else>是</span>
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
          <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
             <!-- 详情弹出框 -->
        <el-dialog :title="type=='add'?'新增银行经理' : '修改银行经理'" v-model="detailVisible" width="55%" top="6vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="110px">
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="选择网点：">
                                <el-select v-model="dataDetail.BankID" size="small" placeholder="请选择银行"
                                  @change="getSiteList">
                                   <el-option :label="bank.BankName" :value="bank.BankID" :key="bank.BankID" v-for="bank in bankList"></el-option>
                                </el-select>
                                   <el-select v-model="dataDetail.AreaCode" size="small" placeholder="请选择区域"
                                  @change="getSiteList">
                                    <el-option :label="area.AreaName" :value="area.AreaCode" :key="area.AreaCode" v-for="area in areaList"></el-option>
                                </el-select>
                                   <el-select v-model="dataDetail.BankSiteID" size="small" placeholder="请选择网点">
                                    <el-option :label="site.BankSiteName" :value="site.BankSiteID" :key="site.BankSiteID" v-for="site in siteList"></el-option>
                                </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                         <el-form-item label="选择用户：">
                               <span style="margin-right:20px">{{user.UserName}} {{user.Tel}}</span>
                                <el-button  size="small" type="primary"  @click="selectUser">点击选择</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                         <el-form-item label="网点负责人：">
                               <el-radio v-model="dataDetail.type" label="0">是</el-radio>
                               <el-radio v-model="dataDetail.type" label="1">否</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
                <div class="dialog-Btn">
                    <el-button size="small" @click="detailVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="addOrUpdateBank">提交</el-button>
                </div>
        </el-dialog>
        <!-- 用户弹出框 -->
        <el-dialog title="选择用户" v-model="userVisible" width="50%" top="7vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="110px">
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="关键字：">
                            <el-input
                                v-model="userKey"
                                size="small"
                                placeholder="请输入用户名或微信名"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                                <el-form-item label="">
                                <el-button  size="small" type="primary"  @click="getUserList">查询</el-button>
                                </el-form-item>
                    </el-col>
                    <el-col :span="22">
                          <el-table
                :data="userList"
                border
                :max-height="600"
            >
                <el-table-column
                    v-for="col in userCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
        
                                <span v-if="(getUserState(scope.row))">
                                    已选中
                                </span>
                                <el-button
                                  v-else
                                size="mini"
                                type="primary"
                                @click="chooseUser(scope.row)">选中</el-button>
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
                           </el-table>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
.dialog-Btn{
    text-align: center;
}
</style>